import axios from "axios";
import { databaseURL } from "../../helpers.js";

// Notifications push — arbitrages du client du 27/09/2026 : périmètre = les 4
// catégories déjà couvertes par la cloche (A25), iOS = incitation à
// l'installation, demande de permission = bouton dans l'écran Compte (jamais
// une popup au chargement), fréquence = une notification par évènement. Le
// socle backend (clés VAPID, abonnements, 5 déclencheurs) est déjà en place.

/** Safari ne délivre le push qu'à une application ajoutée à l'écran d'accueil. */
export const estIOS = () => /iphone|ipad|ipod/i.test(window.navigator.userAgent) && !window.MSStream;

export const estInstalleeSurEcranAccueil = () =>
  window.matchMedia?.("(display-mode: standalone)")?.matches || window.navigator.standalone === true;

/** iOS + pas installée : le push ne peut techniquement pas fonctionner (note du 16/09/2026). */
export const iosSansInstallation = () => estIOS() && !estInstalleeSurEcranAccueil();

/**
 * Installation obligatoire (28/09/2026) — l'exigence d'installation ne porte que sur mobile :
 * sur desktop, les notifications marchent directement dans un onglet, imposer l'installation y
 * serait à la fois artificiel et un obstacle inutile (décision du client).
 */
export const estMobile = () => estIOS() || /android/i.test(window.navigator.userAgent);

const urlBase64VersUint8Array = (base64) => {
  const padding = "=".repeat((4 - (base64.length % 4)) % 4);
  const base64Sure = (base64 + padding).replace(/-/g, "+").replace(/_/g, "/");
  const brut = window.atob(base64Sure);
  return Uint8Array.from([...brut].map((c) => c.charCodeAt(0)));
};

const pushSupporte = () => "serviceWorker" in navigator && "PushManager" in window;

/** L'abonnement en cours sur ce terminal, ou `null` — sans rien demander à l'utilisateur. */
export const obtenirAbonnementActuel = async () => {
  if (!pushSupporte()) return null;
  const registration = await navigator.serviceWorker.ready;
  return registration.pushManager.getSubscription();
};

/** Déclenche la demande de permission du navigateur, puis enregistre l'abonnement côté serveur. */
export const activerNotificationsPush = async (token) => {
  if (!pushSupporte()) {
    throw new Error("Ce navigateur ne prend pas en charge les notifications push");
  }

  const permission = await Notification.requestPermission();
  if (permission !== "granted") {
    throw new Error("Permission refusée");
  }

  const { data } = await axios.get(databaseURL + "push/vapid-public-key", {
    headers: { Authorization: `Bearer ${token}` },
  });
  const clePublique = data?.data?.clePublique;
  if (!clePublique) throw new Error("Clé VAPID indisponible");

  const registration = await navigator.serviceWorker.ready;
  const abonnement = await registration.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64VersUint8Array(clePublique),
  });

  const json = abonnement.toJSON();
  await axios.post(
    databaseURL + "push/subscribe",
    { endpoint: json.endpoint, keys: json.keys },
    { headers: { Authorization: `Bearer ${token}` } }
  );

  return abonnement;
};

/** Retire l'abonnement du terminal ET côté serveur. */
export const desactiverNotificationsPush = async (token) => {
  const abonnement = await obtenirAbonnementActuel();
  if (!abonnement) return;
  const endpoint = abonnement.endpoint;
  await abonnement.unsubscribe();
  await axios.delete(databaseURL + "push/unsubscribe", {
    data: { endpoint },
    headers: { Authorization: `Bearer ${token}` },
  });
};
